import LegacyPublicationSectionRecord from "models/view-models/legacy-publication-section-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";
import { PagedQuery } from "@rsm-hcd/javascript-core";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface LegacyPublicationSectionQueryParams extends PagedQuery {
    /**
     * Array of LegacyPublicationSectionIds to filter results by.
     */
    legacyPublicationSectionIds?: number[];
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint = "legacypublicationsections";
const resourceType = LegacyPublicationSectionRecord;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const LegacyPublicationSectionService = {
    useBatchList: ServiceHookFactory.useBatchedList<
        LegacyPublicationSectionRecord,
        LegacyPublicationSectionQueryParams
    >(resourceType, baseEndpoint),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default LegacyPublicationSectionService;

// #endregion Exports
